import Vue from "vue"; // Vue 原型上已挂载 _axios

const _axios = Vue.prototype.$axios;
const DataApiHost = 'https://data.ayerdudu.com/api/data/up'
//https://data.ayerdudu.com/api/data/up
/**
 * 数据上报服务
 */
const reportService = {
    /**
     * 上报数据
     * @param {object} payload - 上报的数据
     * @returns {Promise} - 返回请求结果
     */
    async sendReport(payload) {
        try {
            // 假设 baseURL 已在 axios 封装时配置
            const response = await _axios.post(DataApiHost, payload);

            console.log("上报成功:", response.data);
            return response.data;
        } catch (error) {
            console.error("上报失败:", error.response?.data || error.message);
            throw error;
        }
    }
};
const ReportPlugin = {
    install(Vue) {
        Vue.prototype.$report = reportService;
    },
};

Vue.use(ReportPlugin);

export { reportService };
export default ReportPlugin;